import { createAction } from '@reduxjs/toolkit'

import { InternalCustomer } from 'types/GlobalCustomer'

// tryGetAllCustomers, tryToggleTestEnvironment
export const getAll = createAction('internal_get_all_customers')
export const getAllSuccess = createAction<InternalCustomer[]>(
  'internal_get_all_customers_success'
)
export const getAllFailed = createAction('internal_get_all_customers_failed')

// tryUpdateCustomer
export const updateOneSuccess = createAction<InternalCustomer>(
  'internal_update_customer_success'
)
